var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpload = function SvgUpload(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF8",
    d: "m12.444 18.667-6.222-6.223h4.667V0H14v12.444h4.667zM21.778 28H3.11A3.11 3.11 0 0 1 0 24.889V6.222a3.11 3.11 0 0 1 3.111-3.11h4.667v3.11H3.11V24.89h18.667V6.222H17.11v-3.11h4.667a3.11 3.11 0 0 1 3.11 3.11V24.89A3.11 3.11 0 0 1 21.779 28"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };